import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PeraturanData = {
  CLW_ISI_IDX: number;
  CLW_ISI_NOMOR: string;
  CLW_ISI_TAHUN: string;
  CLW_MENU_NAME: string;
  CLW_ISI_KETERANGAN: string;
  CLW_BERLAKU: number;
};

type InitialState = {
  dataKarya: PeraturanData[];
  totalData: number;
};

const initialState: InitialState = {
  dataKarya: [
    
    // Add more data items as needed
  ],
  totalData: 100, // Initialize totalData here
};

export const karya = createSlice({
  name: 'karya',
  initialState,
  reducers: {
    replaceAllKarya: (state, action: PayloadAction<PeraturanData[]>) => {
      state.dataKarya = action.payload; // Replace the entire array with the new array
    },
    updateTotalData: (state, action: PayloadAction<number>) => {
      state.totalData = action.payload; // Update the totalData value in the state
    },
  },
});

export const { replaceAllKarya, updateTotalData } = karya.actions;
export default karya.reducer;
